import React from "react";
import {
  JSONContainer,
  JSONKey,
  JSONString,
  JSONNumber,
  JSONBoolean,
  JSONNull,
  JSONIndent,
  JSONObjectContainer,
  JSONArrayContainer,
  JSONLine,
  JSONComma,
} from "./JSONRenderer.styles";

// Parse JSON string to object
const parseJSON = (data) => {
  if (typeof data === "string") {
    try {
      return JSON.parse(data);
    } catch (e) {
      return data;
    }
  }
  return data;
};

export const JSONRenderer = ({ data }) => {
  if (!data) return null;

  const parsedData = parseJSON(data);

  // Recursive component to render JSON
  const RenderJSON = ({ data, level = 0 }) => {
    if (data === null) {
      return <JSONNull>null</JSONNull>;
    }

    if (typeof data === "boolean") {
      return <JSONBoolean>{data.toString()}</JSONBoolean>;
    }

    if (typeof data === "number") {
      return <JSONNumber>{data}</JSONNumber>;
    }

    if (typeof data === "string") {
      return <JSONString>"{data}"</JSONString>;
    }

    if (Array.isArray(data)) {
      if (data.length === 0) return <span>[]</span>;

      return (
        <JSONArrayContainer>
          [
          <JSONIndent level={level}>
            {data.map((item, index) => (
              <JSONLine key={index}>
                <RenderJSON data={item} level={level + 1} />
                {index < data.length - 1 && <JSONComma>,</JSONComma>}
              </JSONLine>
            ))}
          </JSONIndent>
          ]
        </JSONArrayContainer>
      );
    }

    if (typeof data === "object") {
      const keys = Object.keys(data);
      if (keys.length === 0) return <span>{"{}"}</span>;

      return (
        <JSONObjectContainer>
          {"{"}
          <JSONIndent level={level}>
            {keys.map((key, index) => (
              <JSONLine key={key}>
                <JSONKey>"{key}"</JSONKey>:{" "}
                <RenderJSON data={data[key]} level={level + 1} />
                {index < keys.length - 1 && <JSONComma>,</JSONComma>}
              </JSONLine>
            ))}
          </JSONIndent>
          {"}"}
        </JSONObjectContainer>
      );
    }

    return <span>{String(data)}</span>;
  };

  return (
    <JSONContainer>
      <RenderJSON data={parsedData} />
    </JSONContainer>
  );
};
